export default __webpack_public_path__ + "static/media/004-analytics.d41c0223.svg";